import { render, staticRenderFns } from "./Facturas.vue?vue&type=template&id=1378f33e&lang=pug"
import script from "./Facturas.vue?vue&type=script&lang=js"
export * from "./Facturas.vue?vue&type=script&lang=js"
import style0 from "./Facturas.vue?vue&type=style&index=0&id=1378f33e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports